export const CONTENT = {
    PROJECT_CONTENT_RECIVED:'content/projectContentRecived',
    PROJECT_CONTENT_SAVED:'content/projectContentSaved',
    PROJECT_SCHEMA_RECIVED:'content/projectSchemaRecived',
    CONNECTION_ISSUES:'content/connectionIssues',
    PROJECT_ID_DEFINED:'content/projectIdDefined',
    IS_IN_CONFLICT:'content/isInConflict',
    FAVOURITE_TOOL_TIP_SHOWN:'content/favouriteToolTipShown'
}